// test1926
(1926 && 0);
